export const URL_MAIN = '/';

export default {
	// Common

	$window: $(window),
	$document: $(document),
	$html: $(document.documentElement),
	$body: $(document.body),
	$siteContainer: $('.site-container'),
	$page: $('.page'),
	$header: $('.header'),
	$headerBurger: $('.header__burger'),
	$social: $('.social'),

	$lazyImg: $('.lazy-img'),

	$mobileNav: $('.mobile-nav'),
	$mobileNavClose: $('.mobile-nav__close-nav'),

	// Main

	$pageMain: $('.page.main'),
	$mainWoman: $('.main__woman'),
	$mainMan: $('.main__man'),
	$mainLuggage: $('.main__luggage'),
	$mainCircle: $('.main__circle'),
	$mainScroll: $('.main__scroll'),
	$mainTitle: $('.main__title'),
	$mainSubtitle: $('.main__subtitle'),
	$mainItem: $('.main__item'),
	$mainItem1: $('.main__item').eq(0),
	$mainItem2: $('.main__item').eq(1),
	$mainItem3: $('.main__item').eq(2),

	// Test

	$pageTest: $('.page.test'),
	$pageTestDescription: $('.test__description'),
	$pageTestCounter: $('.test__counter'),

	// Result

	$pageResult: $('.page.result'),

	changeAnimationPage: false,
	changePageTest: false,
	goToArticle: false,
};
